import { useNavigate } from "react-router-dom";
import { Icon } from "../../kit";
import { MiniBtn } from "../inspector/rows";
import { useStudioModelId } from "../studioModel";

/**
 * The reference's "Batch Renderer (Beta)" — one button behind a real feature.
 *
 * Ours already exists as a Vault page (`/bulk`, BulkRenderPage: model picking,
 * render agents, BrowserRenderRunner). This is the entry point the reference
 * puts on the rail, not a second implementation of it — the page already reads
 * a handed-over resolution off the navigation state, which is the convention
 * the top bar's "Render" button uses too.
 */
export function BatchRendererPanel() {
  const navigate = useNavigate();
  const modelId = useStudioModelId();

  return (
    <div className="flex flex-col gap-3 p-3">
      <span className="text-[12px] font-semibold text-ed-text-2">
        Batch Renderer
      </span>

      <MiniBtn
        icon="burst_mode"
        primary
        disabled={!modelId}
        onClick={() => navigate("/bulk", { state: { modelId } })}
      >
        Open Batch Renderer
      </MiniBtn>

      {!modelId ? (
        <span className="text-[11px] leading-snug text-ed-text-3">
          Open a model from the Vault first — a batch render runs over saved models.
        </span>
      ) : null}

      <p className="flex items-start gap-1.5 text-[11px] leading-snug text-ed-text-3">
        <Icon name="info" size={13} className="mt-px shrink-0" />
        Renders many models at once at a chosen size. Set the size in the top bar before
        you go — it is handed over with you.
      </p>
    </div>
  );
}
